import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import type { User } from '../types/user';
import { api } from '../api/chat';

interface UserState {
  user: User | null;
  isLogin: boolean;
  loading: boolean;
}

const initialState: UserState = {
  user: null,
  isLogin: false,
  loading: true,
};

// 初始化:读取当前会话用户
export const initAuth = createAsyncThunk('user/init', async () => {
  const user = await api.me();
  return user;
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isLogin = true;
    },
    logout: (state) => {
      state.user = null;
      state.isLogin = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initAuth.pending, (state) => {
        state.loading = true;
      })
      .addCase(initAuth.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLogin = true;
        state.loading = false;
      })
      .addCase(initAuth.rejected, (state) => {
        state.user = null;
        state.isLogin = false;
        state.loading = false;
      });
  },
});

export const { setUser, logout, setLoading } = userSlice.actions;
export default userSlice.reducer;

